var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttachMoney(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8902 10.9C10.6202 10.31 9.89016 9.7 9.89016 8.75C9.89016 7.66 10.9002 6.9 12.5902 6.9C14.3702 6.9 15.0302 7.75 15.0902 9H17.3002C17.2302 7.28 16.1802 5.7 14.0902 5.19V3H11.0902V5.16C9.15016 5.58 7.59016 6.84 7.59016 8.77C7.59016 11.08 9.50016 12.23 12.2902 12.9C14.7902 13.5 15.2902 14.38 15.2902 15.31C15.2902 16 14.8002 17.1 12.5902 17.1C10.5302 17.1 9.72016 16.18 9.61016 15H7.41016C7.53016 17.19 9.17016 18.42 11.0902 18.83V21H14.0902V18.85C16.0402 18.48 17.5902 17.35 17.5902 15.3C17.5902 12.46 15.1602 11.49 12.8902 10.9Z",
    fill: "#666666",
    fillOpacity: 0.87
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachMoney);
export default __webpack_public_path__ + "static/media/attach_money.46413f6b16226d5478f7ac3ed46dde29.svg";
export { ForwardRef as ReactComponent };